<template>
    <div :key="item.type + item.id">
        <div  @click="selectedNotif = false , notifyStore.readNotif(item.id)">
            <nuxt-link :to="'/dashboard/inbox/'+item.actionId"  v-if="item.type == 'NEW_RECEIVED_MESSAGE'" class="notif-item d-flex p-3 border-bottom gap-2 cursor-pointer" :class="[selectedNotif?'bg-primary-25' : '']">
                <div>
                  <span v-if="item.fromUser.picture.includes('placeholder')" class="avatar position-relative" :class="`avatar-${item.fromUser.fullName?.slice(0, 1).toLowerCase()}`">
              
                    {{ item.fromUser.fullName?.slice(0, 1).toUpperCase() }}
           
                </span>
                    <span v-else  class="avatar bg-primary-600">
                        <img :src="item.fromUser.picture" alt="">
                    </span>
                </div>

                <div>
                    <h6 class="fsz-12 lh-sm">{{item.fromUser.fullName + " a t'envoyé un message !" }}</h6>
                    <div><span class="fsz-11 text-gray-400">{{ 'il y a ' + dayjs(item.createdAt).fromNow(true) }}</span> <span >.</span> <span class="fsz-11 text-gray-500 fw-medium">{{item.fromUser.fullName}}</span></div>
                </div>
              </nuxt-link>
              <nuxt-link :to="'/dashboard/items/'"  v-else-if="item.type == 'NEW_OFFER' && item.announcement" class="notif-item d-flex p-3 border-bottom gap-2 cursor-pointer" :class="[selectedNotif?'bg-primary-25' : '']">
              <div>
                <span  class="avatar bg-primary-600">
                    <img :src="item.announcement.pictures[0].fileName" alt="">
                </span>
              </div>

                <div>
                    <h6 class="fsz-12 lh-sm">{{"Vous avez une offre sure l'announce "+ item.announcement.title}}</h6>
                    <span class="fsz-11 text-gray-400">{{ 'il y a ' + dayjs(item.createdAt).fromNow(true) }}</span> <span class="fsz-11">.</span> <span class="fsz-11 text-gray-500">{{item.fromUser.fullName}}</span>
                </div>
              </nuxt-link>
              <nuxt-link :to="'/dashboard/offers/'"   v-else-if="item.type == 'OFFER_ACCEPTED'" class="notif-item d-flex p-3 border-bottom gap-2 cursor-pointer" :class="[selectedNotif?'bg-primary-25' : '']">
                <div>
                  <span  class="avatar bg-primary-600">
                      <img :src="item.announcement.pictures[0].fileName" alt="">
                  </span>
                </div>
  
                  <div>
                      <h6 class="fsz-12 lh-sm">{{"Votre offer sure l'announce "+ item.announcement.title + ' a été accepté'}}</h6>
                      <span class="fsz-11 text-gray-400">{{ 'il y a ' + dayjs(item.createdAt).fromNow(true) }}</span> <span class="fsz-11">.</span> <span class="fsz-11 text-gray-500">{{item.fromUser.fullName}}</span>
                  </div>
                </nuxt-link>
                <nuxt-link  :to="'/dashboard/offers/'"   v-else-if="item.type == 'OFFER_REFUSED'" class="notif-item d-flex p-3 border-bottom gap-2 cursor-pointer" :class="[selectedNotif?'bg-primary-25' : '']">
                    <div>
                      <span  class="avatar bg-primary-600">
                          <img :src="item.announcement.pictures[0].fileName" alt="">
                      </span>
                    </div>
      
                      <div>
                          <h6 class="fsz-12 lh-sm">{{"Votre offer sure l'announce "+ item.announcement.title + ' été refusés'}}</h6>
                          <span class="fsz-11 text-gray-400">{{ 'il y a ' + dayjs(item.createdAt).fromNow(true) }}</span> <span class="fsz-11">.</span> <span class="fsz-11 text-gray-500">{{item.fromUser.fullName}}</span>
                      </div>
                    </nuxt-link>
                  </div>
     


    </div>
</template>

<script setup lang="ts">
import { useNotifyStore } from "~/store/useNotificationStore";

// File Date
import dayjs from "dayjs";
import relativeTime from 'dayjs/plugin/relativeTime.js'
import 'dayjs/locale/fr' // import locale

dayjs.extend(relativeTime)
dayjs.locale('fr')
const notifyStore = useNotifyStore();

const {item} = defineProps(['item'])
const selectedNotif = ref(!item.isRead)

</script>

<style scoped>

</style>
